import { FleetConfiguration } from "../models/FleetConfiguration";

export class GetFleetConfigurationsResponse {
    fleetConfigurations?: FleetConfiguration[];
}